export default __webpack_public_path__ + "42863a5f745122b3ca494001616c04a2.svg";